import Vue from 'vue'

export default function (number, precision) {
  const lang = Vue.i18n.locale() || 'en'
  const langToString = `${lang}-${lang.toUpperCase()}`

  if (!number) {
    return 0
  }

  let options = {}
  if (precision) {
    options.minimumFractionDigits = precision
    options.maximumFractionDigits = precision
  }

  return number.toLocaleString(langToString, options)
}
